import { Card, CardContent } from '@client/components/ui/card';

interface OwnerInformationCardProps {
  ownerInfo: {
    advisorId: string;
    advisorName: string | null;
    advisorEmail: string | null;
    organization: string | null;
  };
}

export function OwnerInformationCard({ ownerInfo }: OwnerInformationCardProps) {
  return (
    <Card className="max-w-[900px] border border-gray-200 bg-gray-50">
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="mt-2 space-y-1 text-sm text-gray-700">
              <p>
                <strong>Subscription Owner's Advisor ID:</strong> {ownerInfo.advisorId}
              </p>
            </div>
            <p className="mt-2 text-sm text-gray-600">
              To manage this subscription, search for the owner's Advisor ID above.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

